module.exports = __webpack_public_path__ + "static/media/GM.814fdc51.svg";